module.exports = __webpack_public_path__ + "img/home-page3.66d183a4.png";